import AbstractField from "../edit/Fields/AbstractField";
import SpeciesRow from "../SpeciesRow";

export default class SpeciesList extends AbstractField {
    rows = [];

    setDrawMode(drawMode) {
        this.show();
    }

    populate(element) {
        this.rows.map(row => row.delete());

        this.rows = element.speciesIds.map(speciesId => {
            let species = this.speciesCollection.get(speciesId);
            let options = ['info'];
            if (this.editMode && this.selection.selected) {
                options.push('remove');
            }
            let row = new SpeciesRow(this.provider, species, this.rowContainer).only(options);
            row.img.mouseClicked(() => { });
            return row;
        });

        this.rows.length == 0
            ? this.label.hide()
            : this.label.show();
    }

    make() {
        this.field = this.p.createDiv().class('input-group');
        this.label = this.p.createElement('h3', 'Plant species')
            .parent(this.field)
            .style('margin-bottom', '0px');
        this.rowContainer = this.p.createDiv()
            .parent(this.field)
            .id('species-list');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.initialized = true;
        return this;
    }

    reset() {
        this.rows.map(row => row.delete());
        this.rows = [];
    }
}
